import { ActivityRecord, FileMetadata, Money, WorkspaceReference } from '../common';

export const AssetStatus = {
  NEW: 'new',
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  DAMAGED: 'damaged',
  ACTIVE: 'active',
  MAINTENANCE: 'maintenance',
  RETIRED: 'retired',
  LOST: 'lost'
} as const;

export type AssetStatus = typeof AssetStatus[keyof typeof AssetStatus];

export type AssetCategory = 'structural' | 'electrical' | 'plumbing' | 'maintenance' | 'security' | 'amenities' | 'furniture' | 'it';

export interface Asset {
  id: string;
  name: string;
  category: AssetCategory;
  subCategory?: string;
  status: AssetStatus;
  location?: string;
  purchaseDate?: Date;
  purchasePrice?: Money;
  block?: {
    id: string;
    name: string;
  };
  floor?: {
    slug: string;
    name: string;
  };
  amenity?: {
    id: string;
    name: string;
  };
  employee?: {
    id: string;
    name: string;
  };
  vendor?: {
    id: string;
    name: string;
  };
  warranty?: {
    startDate: Date;
    endDate: Date;
    details: string;
    provider: string;
  };
  specifications?: {
    brand?: string;
    model?: string;
    serialNumber?: string;
    dimensions?: string;
    weight?: number;
    color?: string;
    // Additional properties for specific asset types
    capacity?: string;
    power?: string;
    flowRate?: string;
    filterSize?: string;
    pumpPower?: string;
    resolution?: string;
    nightVision?: string;
    storage?: string;
    type?: string;
    zones?: string;
    detectors?: string;
    backup?: string;
    cooling?: string;
    heating?: string;
    efficiency?: string;
    fuel?: string;
    fuelCapacity?: string;
    compression?: string;
    includes?: string;
    speed?: string;
    material?: string;
    pressure?: string;
    protection?: string;
    coverage?: string;
  };
  documents?: FileMetadata[];
  workspace?: WorkspaceReference;
  activityRecords?: ActivityRecord[];
  notes?: string;
}
